/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
    PartNumberChangeDetailContract
} from '../../../api/ms-partnumberchanges/contracts/part-number-change-detail.contract';
import {PncDetailModel} from './pnc-detail.model';
import {SupplyingPackingPlantBaseMapper} from '../supplying-packing-plant/supplying-packing-plant-base.mapper';

export class PncDetailMapper {
    private constructor() {
    }

    static fromPartNumberChangeDetailContract(input: PartNumberChangeDetailContract): PncDetailModel {
        let model: PncDetailModel = null;

        if (input != null) {
            model = {
                number: input.number,
                country: input.partner.country.name,
                partner: input.partner,
                shipToParty: input.shipToParty,
                supplyingPackingPlant: SupplyingPackingPlantBaseMapper
                        .fromSupplyingPackingPlantBaseContract(input.supplyingPackingPlant),
                material: input.material,
                salesVariant: input.salesVariant,
                modelCode: input.modelCode,
                colourCode: input.colourCode,
                fullLotNumber: input.fullLotNumber,
                additionalFullLotNumbers:  input.additionalFullLotNumbers?.concat(),
                quantity: input.quantity,
                problemDescription: input.problemDescription,
                user: input.user,
                lastChangeDatetime: input.lastChangeDatetime,
                type: input.type,
                status: input.status,
                trials: input.trials?.concat(),
                newMaterial: input.newMaterial,
                additionalInformation: input.additionalInformation,
                additionalMaterials: input.additionalMaterials?.concat(),
                lastSentBy: input.lastSentBy,
                lastSentOn: input.lastSentOn,
                solvedBy: input.solvedBy,
                solvedOn: input.solvedOn,
                availableActions: input.availableActions?.concat(),
                technicianGroup: input.technicianGroup,
                creationDatetime: input.creationDatetime,
                createdBy: input.createdBy,
                done: input.done,
                doneOn: input.doneOn,
                doneBy: input.doneBy,
                isTodo: input.isTodo,
                previousStatus: input.previousStatus,
                spoNumber: input.spoNumber,
                additionalSpoNumbers: input.additionalSpoNumbers,
                cancelledOn: input.cancelledOn,
                cancellationReason: input.cancellationReason,
                cancelledBy: input.cancelledBy,
                requiresFlashing: input?.requiresFlashing,
                solutionTrials: input?.solutionTrials?.concat(),
                iLevel: input?.iLevel,
                eeAdditionalInformation: input?.eeAdditionalInformation,
                validatedBy: input?.validatedBy,
                alternativeSupplyingPackingPlants: input?.alternativeSupplyingPackingPlants,
                solutionSupplyingPackingPlant: input?.solutionSupplyingPackingPlant
            };
        }
        return model;
    }

}
